<template>
  <article class="rounded p-4 p-md-8 bg-white box-shadow-1 text-start">
    <slot />
  </article>
</template>
